// 申請者
export class ReceptionApplicant {
  public name: string;
  public relationship: string;
  public phoneNumber: string;
  public zipCode: string;
  public address: string;
  public cellPhone: string;
  public email: string;
  public isPatientAddress?: boolean;

  clone(): ReceptionApplicant {
    const newObj = new ReceptionApplicant();
    newObj.name = this.name;
    newObj.relationship = this.relationship;
    newObj.phoneNumber = this.phoneNumber;
    newObj.zipCode = this.zipCode;
    newObj.address = this.address;
    newObj.cellPhone = this.cellPhone;
    newObj.email = this.email;
    newObj.isPatientAddress = this.isPatientAddress;

    return newObj;
  }
}
